import { memo } from 'react';
import Styles from './OutlineText.module.scss';
const OutlineText = memo(function OutlineText({ parentStyles, text, className }) {
    return <>
        <div className={`${Styles.text} ${className}`}>{text}
            <div className={Styles.face}>{text} </div>
        </div>
    </>
});

export default OutlineText;